<template>
<h1>Titanium SDK - BackroundGradient Generator</h1>
<div class="row">
    <CodeBlock :color1="colors.color1" :color2="colors.color2" :flip="colors.flip" :horizontal="colors.horizontal" />
    <form>
        <label for="color1">Color 1</label>
        <input type="color" id="color1" v-model="colors.color1" />
        <label for="color1">Color 2</label>
        <input type="color" id="color2" v-model="colors.color2" />
        <div class="horrow">
            <div>
                <label for="flip">Flip</label>
                <input type="checkbox" id="flip" v-model="colors.flip" />
            </div>
            <div>
                <label for="horizontal">Horizontal</label>
                <input type="checkbox" id="horizontal" v-model="colors.horizontal" />
            </div>
        </div>
    </form>
</div>
</template>
<script>
import CodeBlock from './components/CodeBlock.vue'

export default {
    name: 'App',
    components: {
        CodeBlock,
    },
    data() {
        return {
            colors: {
                color1: "#ffffff",
                color2: "#000000",
                flip: false,
                horizontal: false
            }
        }
    },
    methods: {

    },
}
</script>

<style lang="less" >
* {
    box-sizing: border-box;
    font-family: Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #222;
}

.row {
    display: flex;
}
.horrow {
	display: flex;
	flex-grow: 1;
	flex-direction: row;

	div {
		width: 100%;
		display: block;
	}
}

form {
    margin-left: 40px;
    label {
        width: 100%;
        display: block;
        margin-top: 20px;
        font-weight: bold;
        font-size: 12px;
    }
    input[type=color] {
        width: 200px;
        height: 40px;
    }
	input[type=checkbox] {
		margin-left:0
	}
}

ul {
	margin: 0;
	padding:0;
	li {
		list-style: none;
		a {
			display: inline-block;
			padding: 5px 10px;
		}
	}
}

a,a:visited, a:hover {
	color: #44f;
}

.links {
	margin-top: 50px;
}

</style>
